import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=fbc2f1f0&"
import script from "./ImageGallery.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ImageGallery.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports